import React from 'react';
import TicketAnswerComponent from './TicketAnswerComponent';

export default function Ticket() {
  return (
    <section className="cx--section mt-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="cx--section-title cx--section-dark-title">
              <span className="cx--primary-color">Support</span> ticket <br />
              and your <span className="cx--primary-color">conversation</span>
            </h2>
          </div>
        </div>
        <TicketAnswerComponent />
      </div>
    </section>
  );
}
